var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[(_vm.isMobileLayout)?_c('layout-mobile',[_c(_vm.contactComponent,{tag:"component"})],1):_c('layout-page',[_c(_vm.contactComponent,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }